// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';

const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.genericComponents.errorProvider.';

const TITLES = {
    [AppErrorEnumeration.NO_AUTH_DATA_FROM_QUERY_TOKEN]: `${DOMAIN}noCustomerAuthorizationTitle`,
    [AppErrorEnumeration.AUTH_DATA_CLEAN_FAILED]: `${DOMAIN}noCustomerAuthorizationTitle`,
    [AppErrorEnumeration.NO_REDIRECTED_FORCED_AND_STILL_STAY]: `${DOMAIN}noCustomerAuthorizationTitle`,
    [AppErrorEnumeration.AUTH_WEALTH_REFRESH_TOKEN_FAILED]: `${DOMAIN}noCustomerDataTitle`,
    [AppErrorEnumeration.TMX_LOADED_FAILED_ERROR]: `${DOMAIN}noCustomerDataTitle`,
    [AppErrorEnumeration.CHECKOUT_NO_INFO]: `${DOMAIN}noInfoTitle`,
    [AppErrorEnumeration.REDIRECT_DATA_FAILED]: `${DOMAIN}noInfoTitle`,
    [AppErrorEnumeration.ONBOARDING_TIME_LIMIT_REACHED]: `${DOMAIN}declinedOnboardingTitle`,
    [AppErrorEnumeration.FETCH_STEP_DETAILS_FAILED]: `${DOMAIN}fetchStepDetailsFailedTitle`,
    [AppErrorEnumeration.IFRAME_LOAD_BLOCKED_PROCESS_ERROR]: `${DOMAIN}iframeLoadTitle`,
    [AppErrorEnumeration.PRECONTRACT_GIL_RISK_ERROR]: `${DOMAIN}precontractGilRiskErrorTitle`,
    [AppErrorEnumeration.NO_LOGGED_OR_QUERY_TOKEN]: `${DOMAIN}noTokenTitle`,
    [AppErrorEnumeration.TOKEN_REMOVED]: `${DOMAIN}tokenRemovedTitle`,
    [AppErrorEnumeration.OPERATIVE_TOO_MANY_REQUESTS]: `${DOMAIN}tooManyRequestTitle`,
    [AppErrorEnumeration.REFRESH_TOKEN_REMOVED]: `${DOMAIN}tokenRemovedTitle`,
    [AppErrorEnumeration.STATE_FAILED]: `${DOMAIN}stateFailedTitle`,
    [AppErrorEnumeration.PDF_VIEWER_ERROR]: `${DOMAIN}pdfViewerErrorTitle`,
    [AppErrorEnumeration.UNKNOWN_ERROR]: `${DOMAIN}anyErrorTitle`,
    [AppErrorEnumeration.PAYMENT_MAX_ATTEMPTS]: `${DOMAIN}paymentMaxAttemptsTitle`,
  },
  DESCRIPTIONS = {
    [AppErrorEnumeration.NO_AUTH_DATA_FROM_QUERY_TOKEN]: `${DOMAIN}noCustomerAuthorizationDescription`,
    [AppErrorEnumeration.AUTH_DATA_CLEAN_FAILED]: `${DOMAIN}noCustomerAuthorizationDescription`,
    [AppErrorEnumeration.NO_REDIRECTED_FORCED_AND_STILL_STAY]: `${DOMAIN}noCustomerAuthorizationDescription`,
    [AppErrorEnumeration.AUTH_WEALTH_REFRESH_TOKEN_FAILED]: `${DOMAIN}noCustomerDataAllowedDescription`,
    [AppErrorEnumeration.TMX_LOADED_FAILED_ERROR]: `${DOMAIN}noCustomerDataAllowedDescription`,
    [AppErrorEnumeration.CHECKOUT_NO_INFO]: `${DOMAIN}noInfoDescription`,
    [AppErrorEnumeration.REDIRECT_DATA_FAILED]: `${DOMAIN}noInfoDescription`,
    [AppErrorEnumeration.ONBOARDING_TIME_LIMIT_REACHED]: `${DOMAIN}declinedOnboardingDescription`,
    [AppErrorEnumeration.FETCH_STEP_DETAILS_FAILED]: `${DOMAIN}fetchStepDetailsFailedDescription`,
    [AppErrorEnumeration.IFRAME_LOAD_BLOCKED_PROCESS_ERROR]: `${DOMAIN}iframeLoadDescription`,
    [AppErrorEnumeration.PRECONTRACT_GIL_RISK_ERROR]: `${DOMAIN}precontractGilRiskErrorDescription`,
    [AppErrorEnumeration.NO_LOGGED_OR_QUERY_TOKEN]: `${DOMAIN}noTokenDescription`,
    [AppErrorEnumeration.TOKEN_REMOVED]: `${DOMAIN}tokenRemovedDescription`,
    [AppErrorEnumeration.REFRESH_TOKEN_REMOVED]: `${DOMAIN}tokenRemovedDescription`,
    [AppErrorEnumeration.STATE_FAILED]: `${DOMAIN}stateFailedDescription`,
    [AppErrorEnumeration.OPERATIVE_TOO_MANY_REQUESTS]: `${DOMAIN}tooManyRequestDescription`,
    [AppErrorEnumeration.PDF_VIEWER_ERROR]: `${DOMAIN}pdfViewerErrorDescription`,
    [AppErrorEnumeration.UNKNOWN_ERROR]: `${DOMAIN}anyErrorDescription`,
    [AppErrorEnumeration.PAYMENT_MAX_ATTEMPTS]: `${DOMAIN}paymentMaxAttemptsDescription`,
  },
  CANCEL_BUTTON = `${DOMAIN}cancelButton`;

export { CANCEL_BUTTON, DESCRIPTIONS, TITLES };
